import clsx from 'clsx'
import React, { ButtonHTMLAttributes } from 'react'

import { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Widget.module.scss'

const Widget = React.forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => {
  return (
    <button
      data-testid="widget"
      ref={ref}
      className={clsx(
        textVariants({ variant: 'nextBody', weight: 'semiBold' }),
        Styles.widget,
        className
      )}
      {...props}
    />
  )
})
Widget.displayName = 'Widget'

export default Widget
